import { Button, Input, Sheet, Stack, Box, Textarea } from "@mui/joy";
import React, { useContext, useState } from "react";
import { AlertContext } from "../../context/AlertFlag";
import JSONPretty from 'react-json-pretty';
import axios from "axios";

const adminAxios = axios.create({
    baseURL: process.env.REACT_APP_HOST,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

function AdminLogin() {
    const { addAlert } = useContext(AlertContext);
    const [ adminToken, setAdminToken ] = useState(null);
    const [ isAuthenticated, setIsAuthenticated ] = useState(false);
    const [ unFinishedVisits, setUnfinishedVisits ] = useState([]);

    const isAdmin = async (email, password) => {
        try {
            const auth = await adminAxios.post('/api/login', {"email": email, "password": password});
            const token = auth.data.token

            const checkAdmin = await adminAxios.get('/api/v1/unfinished_visits?minutes_old=1&is_internal=false', 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                }
            });
            setUnfinishedVisits(checkAdmin.data);
            setAdminToken(token)
            setIsAuthenticated(true);
        } catch (error) {
            addAlert("Couldn't verify admin", "danger")
        }
    }


    const sendPlatformSummary = async () => {
        try {
            await adminAxios.post('/api/v1/summary_ondemand', {}, {
                headers: {
                    Authorization: `Bearer ${adminToken}`,
            }});
        } catch(error) {
            addAlert(error, "danger");
        }
    }

    const updateGenerateNote = async (updatedNote, generateNoteId ) => {
        try {
            await adminAxios.put(`/api/v1/admin/generate_notes/${generateNoteId}`,{
                "generated_result": { "value": updatedNote }
            }, { headers: { Authorization: `Bearer ${adminToken}` }})
            addAlert("Updated!", "success")
            const updatedUnfinished = await adminAxios.get('/api/v1/unfinished_visits?minutes_old=1&is_internal=false', 
                {
                    headers: {
                        Authorization: `Bearer ${adminToken}`,
                }
            });
            setUnfinishedVisits(updatedUnfinished.data);
        } catch(error) {
            addAlert("Couldn't update note", "danger");
        }
    }

    const createSubscription = async (userEmail) => {
        try {
            await adminAxios.post('api/v1/subscription_paid_admin', {
                "user_email": userEmail,
                "tier": "premium"
            }, { headers: { Authorization: `Bearer ${adminToken}` }})
            addAlert("Subscription created", "success");
        } catch(error) {
            addAlert("Couldn't create subscription", "danger");
        }
    }

    return <Sheet sx={{ width: "100%", justifySelf: "center", display: "flex", flexDirection: "column", height: "100%", justifyContent: "center" }}>
        {isAuthenticated ? <Sheet sx={{ width: "100%", display: "flex", gap: 4 }}> 
            <Box sx={{maxHeight: "800px", maxWidth: "700px", overflow:"auto" }}>
                <JSONPretty data={unFinishedVisits} mainStyle="white-space:break-spaces"/>
            </Box>
            <Box>
                <Button onClick={sendPlatformSummary} sx={{ width: "300px"}}> Send summary </Button>
            </Box>
            <Box sx={{ width: "500px"}}>
                <form onSubmit={async (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const data = Object.fromEntries(formData);
                    await updateGenerateNote(data['generate_note_result'], data['generate_note_id'])
                }}>
                    <Stack spacing={1}>
                        <Input name="generate_note_id" placeholder='Generate note ID' required/>
                        <Textarea name="generate_note_result" placeholder="Generate note text" required minRows={10}/>
                        <Button type="submit"> UPDATE </Button>
                    </Stack>
                </form>
                <form onSubmit={async (event) => {
                    event.preventDefault();
                    const formData = new FormData(event.currentTarget);
                    const data = Object.fromEntries(formData);
                    await createSubscription(data['user_email']);
                }} style={{ marginTop: "20px"}}>
                    <Stack spacing={1}>
                        <Input name="user_email" placeholder='User Email' required/>
                        <Button type="submit"> CREATE SUBSCRIPTION </Button>
                    </Stack>
                </form>
            </Box>
        </Sheet>
        : <form onSubmit={async (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const data = Object.fromEntries(formData);
            await isAdmin(data['email'], data['password']);
        }}>
            <Stack spacing={1}>
                <Input name="email" placeholder="Email" required/>
                <Input name="password" placeholder="Password" required type="password"/>
                <Button type="submit"> Login </Button>
            </Stack>
        </form>}
    </Sheet>
}


export default AdminLogin